<template>
  <!--
          作者：kmdshop
          时间：2019-10-25
          描述：营业数据
      -->
  <div class="user">
    
    <el-tabs v-model="activeName">
      <el-tab-pane label="经营数据" name="first">
      </el-tab-pane>
      <el-tab-pane label="分公司" name="second">
      </el-tab-pane>
      <el-tab-pane label="业务员" name="third">
      </el-tab-pane>
    </el-tabs>

    <Index v-if="activeName=='first'" ></Index>
    <Compony v-if="activeName=='second'"></Compony>
    <Sales v-if="activeName=='third'"></Sales>
    
     
  </div>
</template>

<script>
  import Index from './bdata/Index.vue';
  import Compony from './bdata/Compony.vue';
  import Sales from './bdata/Sales.vue';
export default {
  components: {
    Index,
    Compony,
    Sales
  },
  data() {
    return {
      activeName:"first"
     
    };
  },
  created() {

  },

  methods: {
   

  }
};
</script>
<style></style>



// WEBPACK FOOTER //
// src/views/report/bdata.vue